/**
 * MicField — small wrapper that overlays a MicButton in the top-right
 * corner of any input or textarea. Use it so admins can dictate every
 * brief / refine / edit field with Whisper.
 *
 *   <MicField value={x} onChange={setX} testid="…">
 *     <input … />        OR        <textarea … />
 *   </MicField>
 *
 * The wrapped child is cloned with extra right-padding so the mic
 * never overlaps the text caret.
 */
import React from "react";
import { MicButton } from "../MicButton";

export function MicField({ value, onChange, apiToken, testid, mode = "append", children }) {
  const child = React.Children.only(children);
  const isTextarea = child.type === "textarea" || child.props?.rows;
  const padded = React.cloneElement(child, {
    style: { ...(child.props.style || {}), paddingRight: 36 },
  });

  return (
    <div style={{ position: "relative" }}>
      {padded}
      <div style={{
        position: "absolute",
        right: 6,
        top: isTextarea ? 6 : "50%",
        transform: isTextarea ? "none" : "translateY(-50%)",
      }}>
        <MicButton value={value} onChange={onChange}
                   apiToken={apiToken} mode={mode} testid={testid} />
      </div>
    </div>
  );
}
